const CUSTOM_STYLES = {
  txtColor: "text-pink",
  accordionHeader: "text-silver-gray",
  customClass: "join-us-accordion",
  accord_open: "jaccord_open",
  accord_close: "jaccord_close",
};
export { CUSTOM_STYLES };
